import { render, staticRenderFns } from "./SystemEdit.vue?vue&type=template&id=fb1661a8&"
import script from "./SystemEdit.vue?vue&type=script&lang=ts&"
export * from "./SystemEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports